// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel/carousel.component.scss
// module id = 181
// module chunks = 0